"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _useServiceCall = _interopRequireDefault(require("@sprinx/react-api-client/useServiceCall"));

var _useDefaults = _interopRequireDefault(require("@sprinx/react-hooks/useDefaults"));

/**
 * returns
 * name: string, - kód promo kódu
 * locale: string, - "locale-region(country)"
 * validTo, - datum, - do kdy je promo kód platný (2020-01-01 13:30:00) nebo null
 * value: number, - procenta slevy promo kódu

**/
var isStaticBuild = typeof document === 'undefined';

function useProductPromoCodeServiceCall(options) {
  return (0, _useServiceCall.default)((0, _useDefaults.default)(options, {
    clientCode: 'api',
    returnOnlyAction: true
  }), function (client, _ref) {
    var taxonomies = _ref.taxonomies;
    return client.call("/v1/products/promoCode", {
      taxonomies: taxonomies
    }, {
      method: 'post'
    });
  });
}

function useProductDeliveryOffsetsServiceCallDummy() {
  return function () {
    return Promise.resolve({
      name: null,
      value: null
    });
  };
}

var _default = isStaticBuild ? useProductDeliveryOffsetsServiceCallDummy : useProductPromoCodeServiceCall;

exports.default = _default;